import { VraagboomAntwoord, VraagboomTimeResultaat } from '@models/vragenboom';
import { Antwoord, Vraag, VariableContent, AntwoordMail, VraagMail } from '@models/claims';
import { VariableHelper } from './variable-helper';
import { FormatHelper } from './../../helpers/format-helper';

export class TijdMapper {
  public static mapResultaten(vraagboomAntwoord: VraagboomAntwoord<VraagboomTimeResultaat>,
    variabeleContent: VariableContent[], vragen: Vraag[]) {
    if (vraagboomAntwoord == null || variabeleContent == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag != null) {
      vraag.id = vraagboomAntwoord.vraag.id;

      if (vraagboomAntwoord.antwoorden != null) {
        for (const antwoord of vraagboomAntwoord.antwoorden) {
          vraag.antwoorden.push(new Antwoord({ id: antwoord.id }));
          const variable: string = VariableHelper.extractVariable(antwoord.variabeleWaarde);

          if (vraagboomAntwoord.resultaat != null) {
            variabeleContent.push(new VariableContent(vraagboomAntwoord.vraag.id, antwoord.id, variable,
              FormatHelper.formatTime(vraagboomAntwoord.resultaat.uren, vraagboomAntwoord.resultaat.minuten)));
          }
        }
      }

      vragen.push(vraag);
    }
  }

  public static mapResultatenMail(vraagboomAntwoord: VraagboomAntwoord<VraagboomTimeResultaat>, vragen: VraagMail[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: VraagMail = new VraagMail;

    if (vraagboomAntwoord.vraag != null) {
      vraag.vraagtitel = vraagboomAntwoord.vraag.titel;
    }

    if (vraagboomAntwoord.resultaat != null && vraagboomAntwoord.antwoorden?.length === 1) {
      vraag.antwoorden = [];
      const antwoord: AntwoordMail = new AntwoordMail();
      if (vraagboomAntwoord?.resultaat?.tijd) {
        antwoord.antwoord = vraagboomAntwoord.resultaat.tijd;
      } else {
        if (vraagboomAntwoord?.vraag?.antwoorden?.length > 0) {
          antwoord.antwoord = vraagboomAntwoord.vraag.antwoorden[0].standaard_waarde;
        }
      }
      vraag.antwoorden.push(antwoord);
    }
    vragen.push(vraag);
  }
}
